// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"799":"de57365f","927":"64dee167"}[chunkId] + ".chunk.js";
};